import QueryInfo from './query-info.container';

export default QueryInfo;
